
import fetch from 'lib/fetch'

export const REQUEST_WORKSPACE_NOTIFICATIONS = 'REQUEST_WORKSPACE_NOTIFICATIONS'
export const REQUEST_WORKSPACE_NOTIFICATIONS_ERROR = 'REQUEST_WORKSPACE_NOTIFICATIONS_ERROR'
export const RECEIVE_WORKSPACE_NOTIFICATIONS = 'RECEIVE_WORKSPACE_NOTIFICATIONS'

export const fetchWorkspaceNotifications = (workspaceSlug) => ({
  types: {
    request: REQUEST_WORKSPACE_NOTIFICATIONS,
    failure: REQUEST_WORKSPACE_NOTIFICATIONS_ERROR,
    receive: RECEIVE_WORKSPACE_NOTIFICATIONS
  },
  shouldCallAPI: state => {
    const { isRequesting, didRequest, didRequestFail } = state.workspaceNotifications
    if (isRequesting) {
      return false
    }
    if (!didRequest) {
      return true
    }
    return didRequestFail
  },
  callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/notifications`).then(res => {
    if (!res.ok) {
      const error = new Error('Unable to fetch workspace notifications')
      error.code = res.status
      throw error
    }
    return res.json()
  }).then(res => res.notifications)
})



// WEBPACK FOOTER //
// ./actions/workspace-notifications.js